// src/features/faq/FaqTable.tsx
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";

import type { FaqItem } from "src/store/faq";

type Props = {
  list: FaqItem[];
  loading: boolean;
  onEdit: (item: FaqItem) => void;
  onDelete: (item: FaqItem) => void; // ✅ 추가
  deletingKey?: string | null; // ✅ (선택) 삭제중 표시용
};

const makeKey = (it: FaqItem) => `${it.faqType}__${it.faqTtl}`;

const FaqTable = ({ list, loading, onEdit, onDelete, deletingKey }: Props) => {
  if (loading) {
    return (
      <Box sx={{ py: 6, textAlign: "center" }}>
        <CircularProgress size={22} />
      </Box>
    );
  }

  return (
    <Table size="small">
      <TableHead>
        <TableRow sx={{ bgcolor: "action.hover" }}>
          <TableCell sx={{ fontWeight: 800, width: 140 }}>타입</TableCell>
          <TableCell sx={{ fontWeight: 800 }}>제목</TableCell>
          <TableCell sx={{ fontWeight: 800, width: 120 }}>활성</TableCell>
          <TableCell sx={{ fontWeight: 800, width: 180, textAlign: "right" }}>액션</TableCell>
        </TableRow>
      </TableHead>

      <TableBody>
        {list.length === 0 ? (
          <TableRow>
            <TableCell colSpan={4}>
              <Box sx={{ py: 6, textAlign: "center", color: "text.disabled" }}>
                데이터가 없습니다.
              </Box>
            </TableCell>
          </TableRow>
        ) : (
          list.map((item, idx) => {
            const key = makeKey(item);
            const isDeleting = deletingKey === key;

            return (
              <TableRow key={`${key}-${idx}`} hover>
                <TableCell>
                  <Chip size="small" label={item.faqType} variant="outlined" />
                </TableCell>

                <TableCell>{item.faqTtl}</TableCell>

                <TableCell>
                  <Chip
                    size="small"
                    label={item.activeYn ? "ACTIVE" : "INACTIVE"}
                    variant={item.activeYn ? "filled" : "outlined"}
                  />
                </TableCell>

                <TableCell align="right">
                  <Stack direction="row" justifyContent="flex-end" gap={1}>
                    <Button size="small" variant="outlined" onClick={() => onEdit(item)}>
                      수정
                    </Button>
                    <Button
                      size="small"
                      color="error"
                      variant="outlined"
                      onClick={() => onDelete(item)}
                      disabled={isDeleting}
                    >
                      {isDeleting ? "삭제중..." : "삭제"}
                    </Button>
                  </Stack>
                </TableCell>
              </TableRow>
            );
          })
        )}
      </TableBody>
    </Table>
  );
};

export default FaqTable;
